<template>
  <div class="page-brand__left">  
    <!-- Delete document -->
    <md-dialog :md-active.sync="deleteDialog">
      <md-dialog-title>
        <span>Delete brand</span>
        <button class="btn btn--close" @click="deleteDialog = false; openUploader = true"></button>
      </md-dialog-title>
      <div class="margin-auto">
        <span>Are you sure you want to delete the next:</span>
        <div class="textTitle margin-medium--top">
          <span class="margin-auto textTitlesilver">{{ documentToDelete }}</span>
        </div>
      </div>
      <md-dialog-actions>
        <div class="md-layout">
          <div class="md-layout-item row">
            <md-button class="md-primary modal-cancel-btn" @click="cancel; openUploader = true; deleteDialog = false">
              Cancel
            </md-button>
          </div>
          <div class="md-layout-item text-right">
            <md-button class="md-primary modal-delete-btn" @click="deleteDocument">Delete</md-button>
          </div>
        </div>
      </md-dialog-actions>
    </md-dialog>

    <!-- Upload and Edit document -->
    <md-dialog :md-active.sync="openUploader">
      <md-dialog-title>
          <span>{{ documentToReplace ? 'Edit document' : 'Upload document' }}</span>
          <button class="btn btn--close" @click="cancel"></button>
      </md-dialog-title>
      <validation-observer v-slot="{ handleSubmit }" tag="div">
        <form @submit.prevent="handleSubmit(handleUpload)" class="form">         
          <div class="form__content">
            <ValidationProvider rules="required" v-slot="{ errors }" tag="div">
              <md-field>
                  <label>Document name</label>
                  <md-input v-model="documentName"></md-input>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
            <ValidationProvider :rules="{required: !documentToReplace}" v-slot="{ errors }" tag="div">
              <md-field>
                <label for="documentFile">Document</label>
                <div class="md-file">                  
                  <input readonly="readonly" :placeholder="documentToReplace ? documentToDelete : ''" class="md-input" v-model="fileNamesToUpload" name="documentFile"/>
                  <input type="file" accept="document/*" @change="filesSelected"/>
                </div>
              </md-field>
              <div class="form__error">{{ errors[0] }}</div>
            </ValidationProvider>
            <div v-if="error" class="form__error">{{ error }}</div>
          </div>
          <md-dialog-actions>
            <div class="md-layout">
              <div class="md-layout-item row">
                <md-button class="md-primary modal-cancel-btn" @click="cancel">Cancel</md-button>
                <a v-if="documentToReplace" class="hrefButton--black margin-medium--left"
                   @click="deleteDialog = true; openUploader = false">Delete Document</a>
              </div>
              <div class="md-layout-item text-right">
                <button
                  class="btn-primary modal-save-btn btn--upload" 
                  :class="UploadButtonState"
                  type="submit"
                >
                  <span v-if="UploadButtonState=='upload-normal'">
                    <span v-if="documentToReplace">save document</span>
                    <span v-else>upload document</span>
                  </span>
                  <span v-else class="upload-state-icon"></span>
                </button>
              </div>
            </div>
          </md-dialog-actions>
        </form>
      </validation-observer>
    </md-dialog>

    <!-- DATA -->
    <img v-if="brand.logo" :srcset="brand.logo.srcset" :alt="brand.name"/>
    <!-- Client contacts -->
    <div class="contact-brand">
      <h3>Client contacts</h3>      
      <InviteAccountsClients :brand="brand" :users="clients" :userType="'client'" :accountView="accountView" :designerView="designerView" />
    </div>
    <div class="contact-brand-list" v-if="brand_clients.length">
      <div class="contact-brand-list-name" v-for="u in brand_clients" :key="u.id">
        <p>{{ u.name }}</p>
        <span>{{ u.email }}</span>
      </div>
    </div>
    <div v-else class="empty-list-text">
      <div>No contacts have been added yet.</div>
    </div>

    <!-- Account list -->
    <div class="contact-brand">
      <h3>Accounts</h3>

      <InviteAccountsClients  :brand="brand" :users="accounts" :userType="'account'"  v-if="accountView" :designerView="designerView"  :accountView="accountView"/>      
    </div>
    <div class="contact-brand-list" v-if="accounts.length">
      <div class="contact-brand-list-name" v-for="u in accounts" :key="u.id">
        <p>{{ u.name }}</p>
        <span>{{ u.email }}</span>
      </div>
    </div>
    <div v-else class="empty-list-text">
      <div>No accounts have been added yet.</div>
    </div>
    <!-- Documents list -->
    <div class="contact-brand-document" v-if="accountView">
      <div class="contact-brand">
        <h3>Documents</h3>
      </div>
      <div v-if="brand.documents">
        <div v-for="document in brand.documents" :key="document.id" class="contact-brand-document-name">    
          <div class="flex-row">
            <button class="btn btn-icon btn--download-document" type="button" @click="forceDownload(CONFIG.uploadURL + document.path + document.file_name, document.file_name_original)">
              <img alt="File icon" class="margin-small--right icon" src="@/assets/img/icons/file.svg"/>
            </button>
            <div class="document__data">
              <div>{{document.name}}</div>
              <div>{{ document.file_name_original }}</div>
            </div>   
          </div>      
          <button type="button" title="Edit document" @click="selectCurrentDocument(document)">
            <img alt="Edit Button" class="editButton icon" src="@/assets/icons/edit.svg"/>
          </button>
        </div>
      </div>
      <!-- empty document list -->
      <div v-else class="empty-list-text">
        <div>You haven’t uploaded any documents yet.</div>
      </div>
      <button class="upload-document-btn" @click="openUploader = true; documentToReplace = false">UPLOAD DOCUMENT</button>
    </div>
  </div>
</template>
<script>
import InviteAccountsClients from '@/components/pagesComponents/brand/InviteAccountsClients.vue'
import {ValidationProvider, ValidationObserver, extend} from 'vee-validate';
import {required} from 'vee-validate/dist/rules';
import {setInteractionMode} from 'vee-validate';

setInteractionMode('eager');
extend('required', {
  ...required,
  message: "This field is required"
});

export default {
  data: function () {
    return {
      openUploader: false,
      deleteDialog: false,
      error: null,
      needUpload: false,
      type: 'no_size',
      filesToUpload: null,
      fileNamesToUpload: undefined,
      successMessage: false,
      documentToReplace: undefined,
      documentToDelete: undefined,
      documentName: null,
      UploadButtonState: 'upload-normal'      
    };
  },
  props: ['brand', 'clients', 'accounts', 'accountView','designerView'],
  components: {    
    InviteAccountsClients,    
    ValidationProvider,
    ValidationObserver
  },
  methods: {
    refreshClients(){
      
     
      if (this.$parent.refreshClients)
      {
        this.$parent.refreshClients();

      }
      if (this.$parent.refreshBrand)
      {
        this.$parent.refreshBrand();

      }
      if (this.$parent.refreshAccounts)
      {
        this.$parent.refreshAccounts();

      }
    },
    deleteDocument() {
      const _this = this;
      this.delete(`documents/${_this.documentToReplace}`, {}, () => {
        _this.showDialog = false;
        _this.deleteDialog = false;
        _this.refreshBrand();
        _this.documentToReplace = undefined;
      
      });
    },
    filesSelected(event) {
      this.needUpload = true;
      this.filesToUpload = event.target.files;
      this.fileNamesToUpload = this.filesToUpload[0].name      
    },
    handleUpload() {
      const _this = this;
      _this.error = null

      if (!this.documentToReplace) {
        this.upload_selected();
      } else if( _this.fileNamesToUpload && _this.filesToUpload) {
        this.delete(`document_to_brand?where[0][0]=where&where[0][1]=document_id&where[0][2]=${this.documentToReplace}&where[1][0]=where&where[1][1]=brand_id&where[1][2]=${this.brand.id}`,
            {},
            () => {
              _this.delete(`documents/${_this.documentToReplace}`, {}, () => {
                _this.upload_selected();
                _this.documentToReplace = undefined;
              })
            })
      } else {
       
        this.UploadButtonState = 'upload-uploading'

        _this.put('documents/' + this.documentToReplace, 
          {
            name: _this.documentName
          }, 
          {},
          function(){
              _this.refreshBrand();
              _this.successMessage = true
              setTimeout(() => {
                _this.UploadButtonState = 'upload-success'
              }, 500);
          },
          function(err){
            console.log(err)
            _this.UploadButtonState = 'upload-normal'
          }
        )
       
      }
    },
    upload_selected: function () {
      if (!this.needUpload)
        return false;
      const _this = this;
      let file = this.filesToUpload[0];
      const formData = new FormData();
      formData.append("files[0]", file);
      formData.append("payment_cluster_id", this.brand.payment_cluster_id);
      formData.append("folder", 'brands');
      formData.append("upload_type", _this.type);
      formData.append("name", _this.documentName);

      this.UploadButtonState = 'upload-uploading'

      //console.log("start_upload");
      this.post(
          "filemanager/upload/document",
          formData,
          {
            headers: {
              "Content-Type": "multipart/form-data"
            }
          },
          function (response) {
            _this.needUpload = false;
            const documentId = response.data.documents[0].id;
            _this.post('document_to_brand', {
              document_id: documentId,
              brand_id: _this.brand.id
            }, {}, () => {
              //console.log('sikeres feltoltes');
              // _this.openUploader = false;
              _this.refreshBrand();
              _this.successMessage = true
              setTimeout(() => {
                _this.UploadButtonState = 'upload-success'
              }, 500);
              
            })
          }, function(err){
            // console.log(err.response.data.error.files[0])
            if (err.response.data.error.files){
              _this.error = err.response.data.error.files[0]
            } else {
              _this.error = 'Something went wrong. Please, try to upload another file'
            }            
            _this.UploadButtonState = 'upload-normal'
          }
      );
    },
    refreshBrand() {
      console.log('branduploadfile refresh')
      if (this.$parent.refreshBrand)
        this.$parent.refreshBrand();
    },
    defState(){      
      this.needUpload = false;
      this.filesToUpload = null;
      this.fileNamesToUpload = null
      this.documentName= null,
      this.UploadButtonState = 'upload-normal' 
    },
    cancel() {
      this.openUploader = false
      this.defState()
    },
    selectCurrentDocument(document){
      this.documentToReplace = document.id
      this.documentToDelete = document.file_name_original
      this.documentName = document.name
      this.openUploader = true
    }
  },
  computed: {
    brand_clients() {
      if (!this.brand.user)
        return [];
      return this.brand.user.filter(user => user.user_type == 'client')
    },
    brand_accounts() {
      if (!this.brand.user)
        return [];
      return this.brand.user.filter(user => user.user_type == 'account')
    }

  }
}
</script>